/// \file passwordUseStates.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import React, {useState} from 'react';
import { SetFilter } from '../../../components/filter/setFilter';
import { passwordUseStateInterface } from './passwordUseStateInterface';
const passwordUseStates = ():passwordUseStateInterface => {

//question type
const questionTypeDropdown = [
  "In what city did you meet your significant other?",
  "What was your childhood nickname",
  "What is the last name of your favorite childhood friend?",
  "What street did you live on in third grade?",
  "What is the middle name of your oldest child?",
  "What was the last name of your third grade teacher?",
  "In what town was your first job",
  "What is the name of the street on which you grew up?",
  "What is the last name of the bast man at your wedding?",
  "What is the last name of the maid of honor at your wedding?",
  "What was the make of your first car?",
  "What is the name of your favorite book?",
  "Who is your favorite author?",
  "Who is your favorite all-time movie character?",
  "Who is your the name of your first pet?",
  "Who do you call?",
  ];
  
  const [question, setquestion] = useState <null|string[]>(questionTypeDropdown);
  const questionFilterChange = (event:{filter:{field:string,operator:string,value:string}}) => {
          const filter=event.filter;
          const currentArray=question;
          const totalArray=questionTypeDropdown;
          const setFilterReturn = SetFilter({filter,currentArray,totalArray});
          setquestion(setFilterReturn.filteredArray);
  };
  
  const [questionValue, setquestionValue] = useState <null|string>(null);
  const questionChange = (e:{value:null|string}) => {
          setquestionValue(e.value);
  };

const [current, setCurrent] = useState<{
    currentPassword:string,
    newPassword:string,
    confirmNewPassword:string,
    resetAnswer:string,
    question:null|string,
}>({
  currentPassword:"",
  newPassword:"",
  confirmNewPassword:"",
  resetAnswer:"",
  question:questionValue,       
});

const passwordVisibility = (e:any) => {
  const buttonId = e.target.id;
  const inputId = buttonId+"-input";
  const inputElement = document.getElementById(inputId) as HTMLInputElement;
  if(inputElement){
    if(inputElement.type=="text"){
      inputElement.type="password";
      e.target.classList.add("strike");
    }
    else if(inputElement.type=="password"){
      inputElement.type="text";
      e.target.classList.remove("strike");
    }
  }
};

  const pairs=[
    {name:"currentPassword",title:"* Current Password",style:"password","values":{onChange:passwordVisibility}},
    {name:"newPassword",title:"* New Password",style:"password","values":{onChange:passwordVisibility}},
    {name:"confirmNewPassword",title:"* Confirm New Password",style:"password","values":{onChange:passwordVisibility}},
    {name:"resetAnswer",title:"* Password Reset Answer",style:"password","values":{onChange:passwordVisibility}},
    {name:"question",title:"* Password Reset Question",style:"single-select","values":{data:question,placeholder:"ANY",startValue:questionValue,onChange:questionChange,onFilterChange:questionFilterChange}},
  ];

  const setCurrentPassword = setCurrent;
  const pairsPassword = pairs;
  return {     
    questionValue,
    setCurrentPassword,
    pairsPassword,
  };
};

export default passwordUseStates;